import { useCopilot } from '../../api/copilot';
import { CONNECTION_LABEL, dotClass } from './util';

/**
 * The connection, as the dot beside the assistant's name.
 *
 * Green only when an agent is actually in the room: a socket that is open with
 * nobody on the other end accepts every question and answers none, which is
 * the state most worth telling apart from "ready". Which specialist agent is
 * answering is deliberately not shown: a handoff is invisible to the reader.
 */
export default function AgentStatusDot() {
  const { connection = 'idle' } = useCopilot();
  const label = `Assistant · ${CONNECTION_LABEL[connection] || connection}`;
  return (
    <span
      className={`chatpane-dot ${dotClass(connection)}`}
      role="img"
      aria-label={label}
      title={label}
    />
  );
}
